import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ToggleButtonElement from '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import styles from './DeviceAdjustedForPets.module.scss.js';

function DeviceAdjustedForPets(_ref) {
  var onChange = _ref.onChange,
    isToggled = _ref.isToggled,
    device = _ref.device;
  var _useState = useState(isToggled),
    _useState2 = _slicedToArray(_useState, 2),
    adjusted = _useState2[0],
    setAdjusted = _useState2[1];
  var toggleAdjusted = function toggleAdjusted() {
    setAdjusted(!adjusted);
    onChange(!adjusted);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButtonElement, {
    dataTestId: "device-adjust-for-pets-".concat(device.deviceLabel),
    onClick: toggleAdjusted,
    isChecked: adjusted,
    text: device.area,
    className: styles.noborder
  }));
}
DeviceAdjustedForPets.propTypes = {
  onChange: PropTypes.func.isRequired,
  isToggled: PropTypes.bool,
  device: PropTypes.shape({
    deviceLabel: PropTypes.string,
    area: PropTypes.string
  })
};
DeviceAdjustedForPets.defaultProps = {
  isToggled: false,
  device: {}
};

export { DeviceAdjustedForPets as default };
